export enum BonificationType {
  FAMILY_QUOTIENT = 'family_quotient',
  DISABILITY = 'disability',
}
